module.exports = __webpack_public_path__ + "assets/flags/gr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/gr.svg
// module id = 502
// module chunks = 0